import * as React from 'react';

import useCurrentUser from 'hooks/useCurrentUser';
import { useGetUsers, useGetTeams } from 'security-app/hooks/useInvestigationsAPI';

export type Assignee = { label: string; type: 'user' | 'team'; id: string };

const useUsersAndTeams = () => {
  const { users } = useGetUsers(true);
  const { teams } = useGetTeams(true);
  const { id: currentUserId, firstName, lastName } = useCurrentUser();
  const currentUserFullName = currentUserId.endsWith('admin') ? 'Administrator' : `${firstName} ${lastName}`;

  return React.useMemo(
    () => ({
      [currentUserId]: { label: currentUserFullName, type: 'user', id: currentUserId } as Assignee,
      ...Object.fromEntries(
        users.map((user) => [user.id, { label: user.full_name, type: 'user', id: user.id } as Assignee]),
      ),
      ...Object.fromEntries(
        teams.map((team) => [team.id, { label: team.name, type: 'team', id: team.id } as Assignee]),
      ),
    }),
    [users, teams, currentUserId, currentUserFullName],
  );
};

export default useUsersAndTeams;
